import { gql } from '@apollo/client';
/**
 * Query to get list of clients the user can access.
 *
 * This query is used during the multi-client Guild Auth flow to show
 * the user which clients they can select from. Requires an authenticated
 * user session.
 *
 * Returns empty list if not authenticated.
 */
export const GET_ACCESSIBLE_CLIENTS = gql `
  query GetAccessibleClients {
    accessibleClients {
      clientId
      compositeId
      code
      name
      pendingApprovalsCount
      accessType
    }
  }
`;
